import script from "./imageDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./imageDialog.vue?vue&type=script&setup=true&lang=js"

import "./imageDialog.vue?vue&type=style&index=0&id=5376e82e&lang=css"

const __exports__ = script;

export default __exports__